import adminCustomersRoutes from '@/router/routing/admin/adminCustomersRoutes'
import adminOrdersRoutes from '@/router/routing/admin/adminOrdersRoutes'
import adminProductionLineRoutes from '@/router/routing/admin/adminProductionLinesRoutes'
import adminProductsRoutes from '@/router/routing/admin/adminProductsRoutes'
import adminTemplatesRoutes from '@/router/routing/admin/adminTemplatesRoutes'
import type { RouteType } from '@rfc/rfc-components-library/types'

const routes: RouteType[] = [
    ...adminOrdersRoutes,
    ...adminCustomersRoutes,
    ...adminProductsRoutes,
    ...adminTemplatesRoutes,
    ...adminProductionLineRoutes
]

export default routes
